<template>
  <div class="m-container">
    <m_header></m_header>
    <!-- 样式二 -->
    <div class="">
      <div style="text-align: center;font-weight: bold;margin: 30px 0 0 0;font-size: 18px;">
<!--        北京六十甲子系统科学研究院有限公司名誉院长-->
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <div style="width: 680px;padding: 10px 0 0 0;">
          <div style="display: flex;flex-wrap: wrap;align-items: center;justify-content: center;">
            <div style="width: 100%;text-align: center;">
              <img src="../assets/img/zhuanjia1.jpg" alt="" style="width: 200px;border-radius: 5px;"/>
            </div>
            <div style="width: 100%;text-align: center;font-size: 16px;padding: 10px 0 0 0;">
              于子迪
            </div>
          </div>
          <div style="height: 10px;"></div>
          <div class="m-ruzhu-tit">人物简介</div>
          <div class="m-ruzhu-cont">于子迪，男，新疆特克斯县人，毕业于中国人民解放军陆军指挥学院，北京六十甲子系统科学研究院有限公司名誉院长，中国深交所董事会秘书资质，国风诗人，中国古地理，易经文化，东方古典器物美学，传统古籍文化等领域研究。</div>

          <div class="m-ruzhu-tit">代表作品</div>
          <div class="m-ruzhu-cont">《如此人生》</div>
          <div class="m-ruzhu-cont">怎能如此痛悲欢，为何如此困尘埃。原来如此循天道，必然如此有兴衰。</div>

          <div class="m-ruzhu-cont">《破红尘》</div>
          <div class="m-ruzhu-cont">弱时慕强拜阳明，强时慕真贯古今。真时慕觉通易理，觉时慕醒看红楼。</div>

          <div class="m-ruzhu-cont">《落子如真》</div>
          <div class="m-ruzhu-cont">根埋冻土养元真，落子寻常淡风尘。棋连成势天道至，银装素裹也是春。</div>

          <div class="m-ruzhu-cont">《本心如觉》</div>
          <div class="m-ruzhu-cont">阅尽山河寻本真，遍交豪杰觅知音。一朝勘破尘浮相，万法根源只此心。</div>

          <div class="m-ruzhu-cont">《终归如醒》</div>
          <div class="m-ruzhu-cont">数阅沉浮大梦醒，尽卸勋禄守田庭。遥瞻星河窥大道，静参轮回天地心。</div>

          <div class="m-ruzhu-tit">研究领域</div>
          <div class="m-ruzhu-cont">中国古地理研究，易经文化研究，东方古典器物美学研究学者，传统古籍文化研究。</div>

          <div class="m-ruzhu-tit">所获荣誉</div>
          <div class="m-ruzhu-cont">2015年，荣获伊犁州首届科学技术大会科技进步一等奖</div>
          <div class="m-ruzhu-cont">2016年，入选新疆维吾尔自治区高层次人才引进工程、全省五大创业人才</div>
          <div class="m-ruzhu-cont">2016年，通过中国深交所董秘考核认证并获得深交所董事会秘书资质</div>
          <div class="m-ruzhu-cont">2021年，北京六十甲子系统科学研究院有限公司名誉院长</div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>
  </div>
</template>

<script>

export default {
  name: 'jiGou',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style>
.m-ruzhu-tit {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 0 0;
}
.m-ruzhu-cont {
  font-size: 16px;
  margin: 5px 0 0 0;
  line-height: 40px;
  text-indent:2em;
}
</style>



// WEBPACK FOOTER //
// src/components/JiGou.vue